import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=2cb608e6&scoped=true&"
import script from "./Dash.vue?vue&type=script&lang=js&"
export * from "./Dash.vue?vue&type=script&lang=js&"
import style0 from "./Dash.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Dash.vue?vue&type=style&index=1&id=2cb608e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb608e6",
  null
  
)

export default component.exports